<template>
  <div
    class="sb_age-gate"
  >
    <div class="sb_age-gate_container">
      <div class="sb_age-gate_content">
        <img
          src="images/eyes2.png"
          class="sb_age-gate_eyes"
        >
        <div class="sb_age-gate_title">
          The content on the following page is suitable for guests over 21 only.
        </div>
        <SbCheckbox>
          Please check the box to confirm you are 21+ to enter.
          <input
            v-model="checkboxAgeGateConfirmation"
            type="checkbox"
          >
        </SbCheckbox>

        <ButtonPill
          button-type="default"
          :disabled="!checkboxAgeGateConfirmation"
          @click="$emit('confirm-age-gate')"
        >
          Enter
        </ButtonPill>
      </div>
    </div>
  </div>
</template>

<script>

import ButtonPill from '@/components/ButtonPill';
import SbCheckbox from '@/components/SbCheckbox';

export default {
  components: {
    ButtonPill,
    SbCheckbox
  },
  data() {
    return {
      checkboxAgeGateConfirmation: false
    };
  }
};
</script>

<style lang="scss">

  .sb_age-gate {
    width: 100%;
    height: 100vh;
    color: $brand-primary;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &_container {
      position: relative;
      max-width: 800px;
      padding: 40px;
      border-radius: 10px;
      border: solid 3px $brand-secondary;

      &:before {
        content: '';
        position: absolute;
        z-index: 1;
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        top: 5px;
        left: 5px;
        background: #ddd;
        border-radius: 5px;
      }
    }

    &_content {
      position: relative;
      z-index: 2;
    }

    &_eyes {
      position: absolute;
      top: 0;
      left: 50%;
      width: 300px;
      transform: translateY(-110%) translateX(-50%);
    }


    &_title {
      font-size: 32px;
      margin: 0 0 10px 0;
    }

    &_text {
      font-size: 20px;
      margin: 0 0 20px 0;
    }

    &_checkbox {
      margin: 40px 0 30px 0;
    }

  }
</style>
